import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from '@angular/core';

import { Btn } from 'src/app/core/interfaces';
import { Dropdown } from 'src/app/core/interfaces/dropdown.interface';
import { hasIn } from 'lodash';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.less'],
})
export class DropdownComponent implements OnInit, OnChanges {
  @Input() dropdown: Dropdown;
  @Input() disabled: boolean = false;
  @Output() itemClickEvent: EventEmitter<string> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {
    this.addDefaultBtnToDropdown(this.dropdown);
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'dropdown': {
            this.addDefaultBtnToDropdown(changes[propName].currentValue);
          }
        }
      }
    }
  }

  addDefaultBtnToDropdown(value: Dropdown) {
    if (!hasIn(value, 'button')) {
      this.dropdown.button = {
        nzTypePrefix: 'ellipsis',
      } as Btn;
    }
  }

  itemClick(e: Event, value: string) {
    e.preventDefault();

    this.itemClickEvent.emit(value);
  }
}
